import { lazy } from 'react';

// Tras un despliegue, una pestaña abierta puede pedir un chunk de JS que ya no existe ("Loading chunk N failed").
// En ese caso se recarga la página una sola vez para traer el index.html nuevo, en vez de mostrar la pantalla de error.
const CLAVE = 'chunk-recarga';

export function esErrorDeChunk(err) {
  const msg = String((err && err.message) || err || '');
  return (err && err.name === 'ChunkLoadError') || /Loading (CSS )?chunk|dynamically imported module/i.test(msg);
}

export default function lazyConReintento(factory) {
  return lazy(() => factory()
    .then(m => { try { sessionStorage.removeItem(CLAVE); } catch { /* sin storage */ } return m; })
    .catch(err => {
      let yaRecargo = false;
      try { yaRecargo = sessionStorage.getItem(CLAVE) === '1'; } catch { /* sin storage */ }
      if (esErrorDeChunk(err) && !yaRecargo) {
        try { sessionStorage.setItem(CLAVE, '1'); } catch { /* sin storage */ }
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    }));
}
